module.exports = __webpack_public_path__ + "static/media/va.e3cb6510.png";